
















import { Vue, Component } from "../vue-ext";
import { Request, HousingCompany } from "../models";

@Component
export default class RequestView extends Vue {
    private request: Request | null = null;
    private requestId: number | null = null;

    private async created() {
        this.root.setTitle(this.$t("menu.requests") as string);
        this.root.setIconClass("icon-tiedotteet");

        const id = parseInt(this.$route.params.id, 10);
        this.requestId = id;

        if (this.requestId) {
            this.request = this.root.getRequest(this.requestId) as Request; 
            this.request.readOn = new Date();
            setTimeout(this.getUpdatedRequest, 1);
        }
    }

    private async getUpdatedRequest() {
        if (this.requestId) {
            await this.root.service.request.GetRequest(this.requestId);
        }
    }
}
